export default __webpack_public_path__ + "static/media/mamut_background_s2.077efc72.jpg";